/**
 * Роли пользователя (SK-5). Значения совпадают с enum `Role` сервера
 * (apps/api/src/generated/prisma/enums.ts) — контракт согласован по строкам, не по импорту
 * (клиент и сервер не делят типы напрямую). У пользователя может быть НЕСКОЛЬКО ролей,
 * права объединяются (Р-13, CLAUDE.md правило 5).
 */
export const ROLES = ["clerk", "commercial", "accounting", "lawyer", "director", "admin"] as const;

export type Role = (typeof ROLES)[number];

/** Русские наименования ролей (термины из ТЗ 4.3 / прототипа). */
export const ROLE_LABELS: Record<Role, string> = {
  clerk: "Делопроизводитель",
  commercial: "Коммерческий отдел",
  accounting: "Бухгалтерия",
  lawyer: "Юрист",
  director: "Директор",
  admin: "Администратор",
};

/** Аутентифицированный пользователь — форма ответа `/api/auth/me` (toPublicUser сервера). */
export interface AuthUser {
  readonly id: string;
  readonly login: string;
  readonly fullName: string;
  readonly roles: Role[];
  /**
   * D-15: пароль выдан администратором и ещё не сменён — интерфейс уводит на экран смены
   * пароля. Настоящий запрет держит сервер (гард отвечает 403 на всё остальное), здесь —
   * только чтобы человек видел объяснение, а не серию отказов.
   */
  readonly mustChangePassword: boolean;
}

/** Читаемый список ролей пользователя, например «Юрист, Администратор». */
export function formatRoles(roles: readonly Role[]): string {
  return roles.map((r) => ROLE_LABELS[r]).join(", ");
}
